"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Minus = function Minus() {
  return _react2.default.createElement(
    "g",
    { id: "minus" },
    _react2.default.createElement("polyline", { id: "Shape", points: "0 285.43 499.29 285.43 499.29 214 0 214" })
  );
};

exports.default = Minus;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Minus.js
// module id = 2969
// module chunks = 4